import React, { useState, useEffect } from 'react';
import { Select, Button, Modal } from 'antd';
import EndpointDetailsModal from 'src/DigitalProtocolModule/components/AddEndpointsModal';
import 'antd/dist/antd.css';
import styles from './index.module.scss';
import './index.scss'


const { Option } = Select;

interface searchableCustomSelectProps {
  options: ({
    value: string,
    label: string
  })[];
  onClickSubmit: (data: any, readonly: boolean) => void;
  unit: string;  
  callCancel: ()=>void;
}

const SearchableCustomSelect = ({ options, onClickSubmit, unit, callCancel  }: searchableCustomSelectProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isNameReadOnly, setNameReadOnly] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // Effect to update initial data when selected option changes
  const [initialData, setInitialData] = useState({});
  useEffect(() => {
    if (selectedOption) {      
      setInitialData({
        endpointName: selectedOption?.label,
        description: '',
        statisticalMethod: '',
        parameters: '',
        confidenceInterval: '',
        significanceLevel: '',
        nSides: '',
        analysisSet: [],
        days: [],
        weeks: []
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    if (options) {      
      setFilteredOptions(options);
    }
  }, [options]);

  const handleAddItemClick = (option) => {    
    setSelectedOption(option);   
    setNameReadOnly(true);
    setIsModalVisible(true);
    callCancel();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    resetState();
  };

  const handleSave = (data) => {    
    setIsModalVisible(false);
    onClickSubmit(data, isNameReadOnly); 
    resetState();
  };

  const handleSearch = (input) => {
    setSearchTerm(input);
    const filtered = options.filter(option =>
      option.label.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredOptions(filtered);
    setDropdownVisible(true);
  };

  const resetState = () => {
    setSelectedOption(null);
    setInitialData({
      endpointName: '',
      description: '',
      statisticalMethod: '',
      parameters: '',
      confidenceInterval: '',
      significanceLevel: '',
      nSides: '',
      analysisSet: [],
      days: [],
      weeks: []
    });
  };

  return (
    <>
      <Select
        showSearch
        className='searchableSelect'
        placeholder="Search..."
        onSearch={handleSearch}
        onFocus={() => setDropdownVisible(true)}
        onBlur={() => setDropdownVisible(false)}
        filterOption={false}  // Custom filtering logic
        dropdownRender={menu => (
          <div
            aria-hidden={!dropdownVisible}  // Control visibility for screen readers
            className={styles.customDropdown}
          >                     
              {filteredOptions?.length > 0 && filteredOptions?.map(option => (
                <div
                  key={option?.value}
                  className={styles.customDropdownItem}                  
                >
                  <span>{option?.label}</span>
                  <Button
                    className={styles.addButton}
                    size="small"
                    type="link"
                    onClick={() => handleAddItemClick(option)}
                  >
                    Add
                  </Button>
                </div>
              ))}                        
          </div>
        )}
      >
        {filteredOptions?.map(option => (
          <Option key={option?.value} value={option?.value}>
            {option?.label}
          </Option>
        ))}
      </Select>

      <EndpointDetailsModal
        visible={isModalVisible}
        onCancel={handleCancel}
        onSave={handleSave}
        isNameReadOnly={isNameReadOnly}
        initialData={initialData}
        isEditData={false}
        unit={unit}
      />
    </>
  );
};

export default SearchableCustomSelect;
